<template>
  <div class="bd-sidebar col-3 col-md-4 col-lg-3">
    <!--    col-sm-3-->
    <div class="py-2">
      <b-card id="our-main-period">
        <label class="bd-sidebar__label" id="main-period"
          >Основной период</label
        >
        <br />
        <date-range-picker
          ref="picker-one"
          id="picker-one"
          :append-to-body="true"
          :locale-data="{
            direction: 'ltr',
            format: 'dd.mm.yyyy',
            separator: ' - ',
            weekLabel: 'W',
            daysOfWeek: ['ВС', 'ПН', 'ВТ', 'СР', 'ЧТ', 'ПТ', 'СБ'],
            monthNames: [
              'Январь',
              'Февраль',
              'Март',
              'Апрель',
              'Май',
              'Июнь',
              'Июль',
              'Август',
              'Сентябрь',
              'Октябрь',
              'Ноябрь',
              'Декабрь',
            ],
            firstDay: 1,
          }"
          :maxDate="maxDate"
          :key="componentDateRange"
          :ranges="ourRanges"
          :singleDatePicker="false"
          :timePicker="false"
          :showWeekNuers="true"
          opens="right"
          :autoApply="true"
          v-model="dateRangeModel"
          :open.sync="open"
          @toggle="onToggle"
          @select="onSelectingDateRange"
          @hover-date="onHoveringDate"
          @start-selection="onStartSelection"
          @finish-selection="onFinishSelection"
        >
          <template v-slot:input>
            <masked-input
              type="text"
              name="dateStart"
              class="mx-input"
              v-model="dateRangeModelMaskStartDate"
              :mask="mask"
              :guide="true"
              :pipe="autoCorrectedDatePipe"
              :keepCharPositions="true"
              placeholderChar="_"
              placeholder="__.__.____ -"
            >
            </masked-input>
            <div class="guion">-</div>
            <masked-input
              type="text"
              name="dateEnd"
              class="mx-input"
              v-model="dateRangeModelMaskEndDate"
              :mask="mask"
              :guide="true"
              :pipe="autoCorrectedDatePipe"
              :keepCharPositions="true"
              placeholderChar="_"
              placeholder="__.__.____"
            >
            </masked-input>
          </template>
        </date-range-picker>
      </b-card>

      <b-card
        v-if="
          currentRouteName === 'positions' || currentRouteName === 'organic'
        "
        id="our-comparing-period"
      >
        <label
          class="bd-sidebar-comparing__label"
          id="compare-period"
          for="comparing_checkbox"
          :class="{ bd_sidebar_comparing__label_disabled: !comparing }"
        >
          <input type="checkbox" id="comparing_checkbox" v-model="comparing" />
          Сравнить с периодом:
        </label>
        <br />
        <date-range-picker
          ref="picker-two"
          id="picker-two"
          :append-to-body="true"
          :locale-data="{
            direction: 'ltr',
            format: 'dd.mm.yyyy',
            separator: ' - ',
            weekLabel: 'W',
            customRangeLabel: 'Custom Range', // 'Custom Range'
            daysOfWeek: ['ВС', 'ПН', 'ВТ', 'СР', 'ЧТ', 'ПТ', 'СБ'],
            monthNames: [
              'Январь',
              'Февраль',
              'Март',
              'Апрель',
              'Май',
              'Июнь',
              'Июль',
              'Август',
              'Сентябрь',
              'Октябрь',
              'Ноябрь',
              'Декабрь',
            ],
            firstDay: 1,
          }"
          :maxDate="maxDate"
          :key="componentDateRangeComparing"
          :ranges="ourRangesComparing"
          :singleDatePicker="false"
          :timePicker="false"
          :showWeekNuers="true"
          opens="right"
          :autoApply="true"
          v-model="dateRangeComparingModel"
          :open.sync="open"
          @toggle="onToggle"
          @select="onSelectingDateRange"
          @hover-date="onHoveringDate"
          @start-selection="onStartSelection"
          @finish-selection="onFinishSelection"
        >
          <template v-slot:input>
            <masked-input
              type="text"
              name="dateComparingStart"
              class="mx-input"
              :class="{ mx_input_disabled: !comparing }"
              v-model="dateRangeComparingModelMaskStartDate"
              :mask="mask"
              :guide="true"
              :pipe="autoCorrectedDatePipe"
              :keepCharPositions="true"
              placeholderChar="_"
              placeholder="__.__.____"
            />
            <div class="guion">-</div>
            <masked-input
              type="text"
              name="dateComparingEnd"
              class="mx-input"
              :class="{ mx_input_disabled: !comparing }"
              v-model="dateRangeComparingModelMaskEndDate"
              :mask="mask"
              :guide="true"
              :pipe="autoCorrectedDatePipe"
              :keepCharPositions="true"
              placeholderChar="_"
              placeholder="__.__.____"
            />
          </template>
        </date-range-picker>
      </b-card>
      <hr class="bd-sidebar__hr" />
      <b-card>
        <label
          id="filters"
          class="bd-sidebar__label"
          >Фильтры</label
        >

        <div
          class="checkbox_filter"
          id="checkbox_filter"
          v-if="currentRouteName !== 'ws'"
        >
          <div class="checkbox_filter__title">Поисковая система</div>
          <div class="checkbox_filter__options">
            <div class="checkbox_filter__option">
              <input
                type="checkbox"
                class="custom-checkbox"
                id="searchEngineGoogle"
                v-model="searchEngines"
                value="google"
              />
              <label for="searchEngineGoogle">Google</label>
            </div>
            <div class="checkbox_filter__option">
              <input
                type="checkbox"
                class="custom-checkbox"
                id="searchEngineYandex"
                v-model="searchEngines"
                value="yandex"
              />
              <label for="searchEngineYandex">Yandex</label>
            </div>
          </div>
        </div>

        <div class="checkbox_filter">
          <div class="checkbox_filter__title">Устройства</div>
          <div class="checkbox_filter__options">
            <div class="checkbox_filter__option">
              <input
                type="checkbox"
                class="custom-checkbox"
                id="deviceTypesDesktop"
                v-model="deviceTypes"
                value="desktop"
              />
              <label for="deviceTypesDesktop">Desktop</label>
            </div>
            <div class="checkbox_filter__option">
              <input
                type="checkbox"
                class="custom-checkbox"
                id="deviceTypesMobile"
                v-model="deviceTypes"
                value="mobile"
              />
              <label for="deviceTypesMobile">Mobile</label>
            </div>
          </div>
        </div>

        <multiselect
          v-if="currentRouteName !== 'ws'"
          class="multiselect-sidebar"
          :class="{
            active: keywordsTypes && keywordsTypes.length,
          }"
          ref="multiselectKeywordType"
          v-model="keywordsTypesModel"
          :options="optionsKeywordsTypes"
          deselect-label="✓"
          select-label=""
          selectedLabel="✓"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          :searchable="false"
          :taggable="false"
          placeholder="Тип слова"
          label="title"
          track-by="value"
          openDirection="auto"
          :allowEmpty="true"
          @input="selectKeywordsTypes"
          :disabled="!optionsKeywordsTypes || !optionsKeywordsTypes.length"
        >
          <template
            slot="beforeList"
            v-if="optionsKeywordsTypes && optionsKeywordsTypes.length"
          >
            <div class="string-btn">
              <button
                type="button"
                class="btn btn-sm clear_btn"
                @click="selectKeywordsTypes([])"
                :disabled="!keywordsTypes.length"
              >
                Отменить все
              </button>
            </div>
          </template>
          <template
            slot="selection"
            slot-scope="{ values, search, isOpen }"
            v-if="keywordsTypes"
          >
            <span class="multiselect__single" v-if="keywordsTypes.length > 1"
              >Выбрано {{ values.length }} позиции</span
            >
            <span
              class="multiselect__single"
              v-else-if="keywordsTypes.length === 1"
              >{{ values[0].title }}</span
            >
            <span
              class="multiselect__single"
              v-else-if="keywordsTypes.length === 0 && isOpen"
              >Тип слова</span
            >
          </template>
        </multiselect>
        <multiselect
          :class="{
            active: keywords && keywords.length,
          }"
          class="keywords multiselect-sidebar"
          v-model="keywordsModel"
          deselect-label="✓"
          select-label=""
          selectedLabel="✓"
          :options="filteredOptionsKeywords"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          placeholder="Ключевые слова"
          label="title"
          :searchable="true"
          track-by="id"
          :taggable="false"
          openDirection="below"
          :allowEmpty="true"
          @input="selectKeywords"
          :disabled="!optionsKeywords || !optionsKeywords.length"
        >
          <template
            slot="beforeList"
            v-if="optionsKeywords && optionsKeywords.length"
          >
            <div class="before_list stickied">
              <button
                type="button"
                class="btn btn-sm clear_btn"
                @click="selectKeywords([])"
                :disabled="!keywords.length"
              >
                Отменить все
              </button>
            </div>
          </template>
          <template
            slot="selection"
            slot-scope="{ values, search, isOpen }"
            v-if="keywords"
          >
            <span class="multiselect__single" v-if="keywords.length > 1"
              >Выбрано {{ values.length }} позиции</span
            >
            <span
              class="multiselect__single"
              v-else-if="keywords.length === 1"
              >{{ values[0].title }}</span
            >
            <span
              class="multiselect__single"
              v-else-if="keywords.length === 0 && isOpen"
              >Ключевые слова</span
            >
          </template>
          <template slot="option" slot-scope="props">
            <div class="option__desc">
              <span
                class="option__title"
                :class="{
                  moving: props.option.title.length > maxSymbolsNumber,
                }"
                >{{ props.option.title }}</span
              >
            </div>
          </template>
        </multiselect>

        <multiselect
          :class="{
            active: geoLocations && geoLocations.length,
          }"
          class="multiselect-sidebar"
          ref="multiselectGeoLocation"
          v-model="geoLocationModel"
          :options="optionsGeoLocation"
          deselect-label="✓"
          select-label=""
          selectedLabel="✓"
          :multiple="true"
          :close-on-select="false"
          :searchable="false"
          :taggable="false"
          placeholder="География"
          label="name"
          track-by="id"
          openDirection="auto"
          @input="selectGeoLocations"
          @focus="isOpenGeoLocation = true"
          @blur="isOpenGeoLocation = false"
        >
          <template
            slot="beforeList"
            v-if="optionsGeoLocation && optionsGeoLocation.length"
          >
            <div class="string-btn">
              <button
                type="button"
                class="btn btn-sm clear_btn"
                @click="selectGeoLocations([])"
                :disabled="!geoLocations.length"
              >
                Отменить все
              </button>
            </div>
          </template>
          <template
            slot="selection"
            slot-scope="{ values, search, isOpen }"
            v-if="geoLocations"
          >
            <span class="multiselect__single" v-if="geoLocations.length > 1"
              >Выбрано {{ values.length }} позиции</span
            >
            <span
              class="multiselect__single"
              v-else-if="geoLocations.length === 1"
              >{{ values[0].name }}</span
            >
            <span
              class="multiselect__single"
              v-else-if="geoLocations.length === 0 && isOpen"
              >География</span
            >
          </template>
          <template slot="option" slot-scope="props">
            <div class="option__desc">
              <span
                class="option__title"
                :class="{ moving: props.option.name.length > maxSymbolsNumber }"
                >{{ props.option.name }}</span
              >
            </div>
          </template>
        </multiselect>

        <hr class="bd-sidebar__hr" />

        <div
          v-if="
            currentRouteName === 'positions' || currentRouteName === 'organic'
          "
          class="slices"
        >
          <!--                          <h3 id="some-graphs">Несколько графиков</h3>-->
          <label id="some-graphs" class="bd-sidebar__label"
            >Срезы</label
          >

          <multiselect
            class="multiselect-sidebar"
            :class="{
              active: slice,
            }"
            v-model="sliceModel"
            :options="filteredOptionsSlices"
            @input="selectSlice"
            track-by="value"
            :searchable="false"
            :multiple="false"
            :close-on-select="false"
            :clear-on-select="true"
            deselect-label="✓"
            select-label=""
            selectedLabel="✓"
            placeholder="Выберите срез"
            label="title"
            openDirection="auto"
          >
            <template
              slot="selection"
              slot-scope="{ values, search, isOpen }"
              v-if="slice"
            >
              <span class="multiselect__single" v-if="slice.length === 1">
                {{ values[0].title }}</span
              >
            </template>
            <template
              slot="selection"
              slot-scope="{ values, search, isOpen }"
              v-if="!slice"
            >
              <span class="multiselect__single" v-if="isOpen"
                >Выберите срез</span
              >
            </template>
          </multiselect>
        </div>
        <div class="my-3">
          <b-button
            @click="
              filterFormSubmit();
              $event.target.blur();
            "
            >Применить
          </b-button>
          <b-button
            @click="resetFiltersToDefault(); $event.target.blur();"
            :class="{ 'btn-secondary': !areFiltersApplied, 'btn-warning': areFiltersApplied }"
            class="ml-2"
            :disabled="!areFiltersApplied"
          >Сбросить
          </b-button>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import DateRangePicker from "vue2-daterange-picker";
import Multiselect from "vue-multiselect";
import MaskedInput from "vue-text-mask";
import Moment from "moment";
import {extendMoment} from "moment-range";
import createAutoCorrectedDatePipe from "text-mask-addons/dist/createAutoCorrectedDatePipe";
//you need to import the CSS manually (in case you want to override it)
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import EventHubListenerMixin from "../common/mixins/EventHubListener";
import {mapActions, mapGetters} from "vuex";

const moment = extendMoment(Moment);

export default {
  name: "FilterPicker",
  components: {
    DateRangePicker,
    MaskedInput,
    Multiselect,
    EventHubListenerMixin,
  }, // DatepickerMainComponent, DatepickerExtraComponent,

  data() {
    let today = moment();
    let yesterday = today
      .clone()
      .subtract(1, "days")
      .set({ hour: 10 })
      .toDate();
    let sevenDaysAgo = today
      .clone()
      .subtract(7, "days")
      .set({ hour: 10 })
      .toDate();
    let thirtyDaysAgo = today
      .clone()
      .subtract(30, "days")
      .set({ hour: 10 })
      .toDate();
    let thisMonthStart = today
      .clone()
      .startOf("month")
      .set({ hour: 10 })
      .toDate();
    let previousMonthStart = today
      .clone()
      .subtract(1, "months")
      .startOf("month")
      .set({ hour: 10 })
      .toDate();
    let previousMonthEnd = today
      .clone()
      .subtract(1, "months")
      .endOf("month")
      .set({ hour: 10 })
      .toDate();
    let thisQuarterStart = today
      .clone()
      .quarter(today.clone().quarter())
      .startOf("quarter")
      .set({ hour: 12 })
      .toDate();
    let previousQuarterStart = today
      .clone()
      .quarter(today.clone().subtract(1, "quarter").quarter())
      .startOf("quarter")
      .set({ hour: 10 })
      .toDate();
    let previousQuarterEnd = today
      .clone()
      .quarter(today.clone().subtract(1, "quarter").quarter())
      .endOf("quarter")
      .set({ hour: 10 })
      .toDate();

    if (today.clone().quarter() === 1) {
      previousQuarterStart = today
        .clone()
        .subtract(1, "year")
        .quarter(4)
        .startOf("quarter")
        .set({ hour: 10 })
        .toDate();
      previousQuarterEnd = today
        .clone()
        .subtract(1, "year")
        .quarter(4)
        .endOf("quarter")
        .set({ hour: 10 })
        .toDate();
    }

    let ourRanges = {
      "Последние 7 дн.": [sevenDaysAgo, yesterday],
      "Последние 30 дн.": [thirtyDaysAgo, yesterday],
      "Этот месяц": [thisMonthStart, yesterday],
      "Предыдущий месяц": [previousMonthStart, previousMonthEnd],
      "Этот квартал": [thisQuarterStart, yesterday],
      "Предыдущий квартал": [previousQuarterStart, previousQuarterEnd],
    };

    if (today === moment().startOf("month")) {
      ourRanges["Этот месяц"] = [today, today];
    }

    return {
      ourRanges: ourRanges,
      ourRangesComparing: ourRanges,
      isOpenKeywordType: false,
      isOpenKeywords: false,
      isOpenGeoLocation: false,
      isOpenSlicesType: false,
      neededSlice: false,
      exportingRequestData: {},
      exportingRequestComparingData: {},
      filterSearchEngine: [],
      filterDeviceType: [],
      filterKeyword: [],
      filterKeywordType: [],
      filterGeoLocation: [],
      filterSlices: null,
      filterAdvertisers: null,

      optionsSlices: [
        { title: "Поисковая система", value: "src" },
        { title: "Устройства", value: "dsl" },
        { title: "Тип слова", value: "kwt" },
        { title: "География", value: "ggr" },
        { title: "Время сбора", value: "clt" },
      ],

      optionsAdvertisers: [],

      events: [],
      currentProject: null,
      kw_types: {},
      value: "",
      open: false,
      mask: [/\d/, /\d/, ".", /\d/, /\d/, ".", /\d/, /\d/, /\d/, /\d/],
      selectedDate: null,
      maskedDate: null,
      maskedDateComparing: null,
      maxDate: today.toDate(),
      componentDateRange: false,
      componentDateRangeComparing: false,

      maxSymbolsNumber: 28,
      selectingDateRange: false,
      startingDate: "",
      isRangeSelected: true,
    };
  },

  computed: {
    ...mapGetters("filters", [
      "advertisersFilter",
      "getSearchEngines",
      "getDeviceTypes",
      "geoLocations",
      "optionsKeywords",
      "keywords",
      "optionsKeywordsTypes",
      "keywordsTypes",
      "slice",
      "dateRange",
      "dateRangeComparing",
      "dateRangeString",
      "dateRangeStringStartDate",
      "dateRangeStringEndDate",
      "dateRangeComparingStringStartDate",
      "dateRangeComparingStringEndDate",
      "dateRangeComparingString",
      "comparingState",
      "competitorsFilter",
      "optionsGeoLocation",
      "searchEngines",
    ]),
    ...mapGetters(["competitors"]),
    ...mapGetters('user', ['isSuperuser']),
    filteredOptionsKeywords() {
      // Показываем только ключевые слова выбранных типов; если типы не выбраны — все
      if (!this.keywordsTypes || this.keywordsTypes.length === 0) {
        return this.optionsKeywords || [];
      }
      const allowedTypes = new Set(this.keywordsTypes.map(t => Number(t.value)));
      return (this.optionsKeywords || []).filter(k => {
        // Если у ключа нет kw_type — скрываем его, когда выбран фильтр по типу
        const kwTypeVal = k.kw_type !== undefined && k.kw_type !== null ? Number(k.kw_type) : null;
        return kwTypeVal !== null && allowedTypes.has(kwTypeVal);
      });
    },
    filteredOptionsSlices() {
      // Фильтруем опции срезов: "Время сбора" видно только для superuser
      return this.optionsSlices.filter(slice => {
        if (slice.value === "clt") {
          return this.isSuperuser;
        }
        return true;
      });
    },
    ...mapGetters("keywords_organic", [
      "onePeriod",
      "resetStatus",
      "onePeriodValue",
    ]),
    autoCorrectedDatePipe() {
      return createAutoCorrectedDatePipe("dd.mm.yyyy", {
        minYear: 2020,
        maxYear: moment().year(),
      });
    }, // developer can verify years starting project
    searchEngines: {
      get() {
        return this.getSearchEngines;
      },
      set(arr) {
        this.$store.commit("filters/updateSearchEngines", arr);
      },
    },
    deviceTypes: {
      get() {
        return this.getDeviceTypes;
      },
      set(arr) {
        // На странице USP только одно устройство: выбор Mobile снимает Desktop и наоборот
        if (this.currentRouteName === "usp" && Array.isArray(arr)) {
          if (arr.length === 0) return;
          if (arr.length > 1) arr = [arr[arr.length - 1]];
        }
        this.$store.commit("filters/updateDeviceTypes", arr);
      },
    },
    comparing: {
      get() {
        return this.comparingState;
      },
      set(v) {
        this.selectComparing(v);
      },
    },
    dateRangeModel: {
      get() {
        return this.dateRange;
      },
      set(v) {
        this.setDateRange(v, "dateRange");
      },
    },
    dateRangeModelMaskStartDate: {
      get() {
        return this.dateRangeStringStartDate;
      },
      set(v) {
        this.setDateRange(v, "dateRange", "start");
      },
    },
    dateRangeModelMaskEndDate: {
      get() {
        return this.dateRangeStringEndDate;
      },
      set(v) {
        this.setDateRange(v, "dateRange", "end");
      },
    },
    dateRangeComparingModel: {
      get() {
        return this.dateRangeComparing;
      },
      set(v) {
        this.setDateRange(v, "dateRangeComparing");
      },
    },
    dateRangeComparingModelMaskStartDate: {
      get() {
        return this.dateRangeComparingStringStartDate;
      },
      set(v) {
        this.setDateRange(v, "dateRangeComparing", "start");
      },
    },
    dateRangeComparingModelMaskEndDate: {
      get() {
        return this.dateRangeComparingStringEndDate;
      },
      set(v) {
        this.setDateRange(v, "dateRangeComparing", "end");
      },
    },
    keywordsTypesModel: {
      get() {
        return this.keywordsTypes;
      },
      set(v) {
        this.$store.commit("filters/updateKeywordsTypes", v);
      },
    },
    geoLocationModel: {
      get() {
        return this.geoLocations;
      },
      set(v) {
        this.$store.commit("filters/updateGeoLocations", v);
      },
    },
    keywordsModel: {
      get() {
        return this.keywords;
      },
      set(v) {
        this.$store.commit("filters/updateKeywords", v);
      },
    },
    sliceModel: {
      get() {
        return this.slice;
      },
      set(v) {
        this.selectSlice(v);
      },
    },
    currentRouteName() {
      return this.$route.name;
    },
    
    // Проверяем, применены ли фильтры (не в дефолтном состоянии)
    areFiltersApplied() {
      // Проверяем поисковые системы (дефолт: ["yandex", "google"])
      const defaultSearchEngines = ["yandex", "google"];
      const searchEnginesChanged = !this.arraysEqual(this.searchEngines, defaultSearchEngines);
      
      // Проверяем типы устройств (дефолт: ["desktop", "mobile"])
      const defaultDeviceTypes = ["desktop", "mobile"];
      const deviceTypesChanged = !this.arraysEqual(this.deviceTypes, defaultDeviceTypes);
      
      // Проверяем типы ключевых слов (дефолт: [])
      const keywordsTypesChanged = this.keywordsTypes && this.keywordsTypes.length > 0;
      
      // Проверяем ключевые слова (дефолт: [])
      const keywordsChanged = this.keywords && this.keywords.length > 0;
      
      // Проверяем геолокации (дефолт: [])
      const geoLocationsChanged = this.geoLocations && this.geoLocations.length > 0;
      
      // Проверяем срез (дефолт: null)
      const sliceChanged = this.slice !== null;
      
      // Проверяем фильтр рекламодателей (дефолт: null)
      const advertisersFilterChanged = this.advertisersFilter !== null;
      
      return searchEnginesChanged || deviceTypesChanged || keywordsTypesChanged || 
             keywordsChanged || geoLocationsChanged || sliceChanged || advertisersFilterChanged;
    },
  },

  watch: {
    keywordsTypes(newVal) {
      // Если выбран тип слова, оставляем только ключевые слова этого типа
      if (!newVal || newVal.length === 0) {
        return;
      }
      const allowed = new Set(newVal.map(t => Number(t.value)));
      const filtered = (this.keywords || []).filter(k => {
        const kwTypeVal = k.kw_type !== undefined && k.kw_type !== null ? Number(k.kw_type) : null;
        return kwTypeVal !== null && allowed.has(kwTypeVal);
      });
      if (filtered.length !== (this.keywords || []).length) {
        this.selectKeywords(filtered);
      }
    },
  },

  async mounted() {
    await this.filterFormSubmit()
  },

  methods: {
    // Вспомогательный метод для сравнения массивов
    arraysEqual(a, b) {
      if (!a || !b) return false;
      if (a.length !== b.length) return false;
      return a.every((val, index) => val === b[index]);
    },
    
    // Метод для сброса всех фильтров к дефолтным значениям
    resetFiltersToDefault() {
      // Сбрасываем поисковые системы к дефолту
      this.searchEngines = ["yandex", "google"];
      
      // Сбрасываем типы устройств к дефолту
      this.deviceTypes = ["desktop", "mobile"];
      
      // Сбрасываем типы ключевых слов
      this.keywordsTypesModel = [];
      
      // Сбрасываем ключевые слова
      this.keywordsModel = [];
      
      // Сбрасываем геолокации
      this.geoLocationModel = [];
      
      // Сбрасываем срез
      this.sliceModel = null;
      
      // Сбрасываем фильтр рекламодателей
      this.selectAdvertisersFilter(null);
      
      // Применяем изменения
      this.filterFormSubmit();
    },
    
    ...mapActions("filters", [
      "selectGeoLocations",
      "selectKeywordsTypes",
      "selectKeywords",
      "selectSlice",
      "selectDateRange",
      "selectDateRangeComparing",
      "selectComparing",
      "selectCompetitorsFilter",
      "fetchOptionsKeywords",
      "fetchOptionsGeoLocations",
      "fetchOptionsKeywordsTypes",
    ]),

    ...mapActions("sov_dashboard", ["fetchSovReports", "updateIsCorrectPeriod"]),
    ...mapActions("keywords", ["fetchKeywordsStats"]),
    ...mapActions("usp", ["fetchUspListSelected"]),
    ...mapActions("wordstat", ["fetchWordstat"]),
    ...mapActions("organic_sov_dashboard", ["fetchOrganicSovReports"]),
    ...mapActions("keywords_organic", [
      "fetchKeywordsOrganicStats",
      "selectResetStatus",
      "selectOnePeriod",
      "selectOnePeriodValue",
    ]),
    ...mapActions("filters", ["selectAdvertisersFilter"]),

    onToggle(open, togglePicker) {
      if (!open && this.selectingDateRange) {
        togglePicker();
      }
      this.selectingDateRange = false;
      this.isRangeSelected = true;
    },

    onSelectingDateRange() {
      this.selectingDateRange = true;
    },

    onHoveringDateCondition(pickerCurrent, hoverDate) {
      if (hoverDate <= this.startingDate) {
        pickerCurrent["in_selection"] = false;
        if (pickerCurrent["end"] <= pickerCurrent["start"]) {
          pickerCurrent["end"] = pickerCurrent["start"];
        }
      } else if (hoverDate > this.startingDate && this.isRangeSelected) {
        pickerCurrent["in_selection"] = false;
      } else {
        pickerCurrent["in_selection"] = true;
      }
    },

    onHoveringDate(hoverDate) {
      if (this.$refs["picker-one"] && this.$refs["picker-one"]["open"]) {
        this.onHoveringDateCondition(this.$refs["picker-one"], hoverDate);
      }
      if (this.$refs["picker-two"] && this.$refs["picker-two"]["open"]) {
        this.onHoveringDateCondition(this.$refs["picker-two"], hoverDate);
      }
    },

    onStartSelection(startDate) {
      this.startingDate = startDate;
      this.isRangeSelected = false;
      if (this.$refs["picker-one"] && this.$refs["picker-one"]["open"]) {
        this.$refs["picker-one"]["in_selection"] = true;
      }
      if (this.$refs["picker-two"] && this.$refs["picker-two"]["open"]) {
        this.$refs["picker-two"]["in_selection"] = true;
      }
    },

    onFinishSelection(endDate) {
      if (this.$refs["picker-one"] && this.$refs["picker-one"]["open"]) {
        this.$refs["picker-one"]["start"] = this.startingDate;
        this.$refs["picker-one"]["end"] = endDate;
      }
      if (this.$refs["picker-two"] && this.$refs["picker-two"]["open"]) {
        this.$refs["picker-two"]["start"] = this.startingDate;
        this.$refs["picker-two"]["end"] = endDate;
      }
      this.isRangeSelected = true;
    },

    dateRangePipe(dateRange) {
      let a = dateRange.split("-");
    },

    sliceFiltersRefreshing(slice) {
      if (slice === "src") {
        document.getElementById("searchEngineGoogle").checked = true;
        document.getElementById("searchEngineYandex").checked = true;
      } else if (slice === "dsl") {
        document.getElementById("deviceTypesDesktop").checked = true;
        document.getElementById("deviceTypesMobile").checked = true;
      } else if (slice === "kwt") {
        this.selectKeywordsTypes([]);
      } else if (slice === "ggr") {
        this.selectGeoLocations([]);
      } else if (slice === "clt") {
        // Для среза по времени сбора нет зависимых фильтров
      } else throw new TypeError("Unknown slice type");
    },

    async filterFormSubmit() {
      let route = this.currentRouteName;
      const promises = []
      if (route === "keywords") {
         const fetchKeywordsStats = this.fetchKeywordsStats();
        promises.push(fetchKeywordsStats)
      } else if (route === "positions") {
        if (this.slice) {
          let slice = this.slice["value"];
          this.sliceFiltersRefreshing(slice);
        }
        const fetchSovReports = this.fetchSovReports();
        const fetchKeywordsStats = this.fetchKeywordsStats();
        promises.push(fetchSovReports)
        promises.push(fetchKeywordsStats)
      } else if (route === "usp") {
        const fetchUspListSelected = this.fetchUspListSelected();
        promises.push(fetchUspListSelected)
      } else if (route === "organic") {
        if (this.slice) {
          let slice = this.slice["value"];
          this.sliceFiltersRefreshing(slice);
        }
        await this.selectAdvertisersFilter(this.advertisersFilter);
        const fetchOrganicSovReports = this.fetchOrganicSovReports();
        promises.push(fetchOrganicSovReports)
        if (this.comparingState) {
          const fetchKeywordsOrganicStats = this.fetchKeywordsOrganicStats([this.onePeriodValue, null]);
          promises.push(fetchKeywordsOrganicStats)
        } else {
          const fetchKeywordsOrganicStats = this.fetchKeywordsOrganicStats([null, null]);
          promises.push(fetchKeywordsOrganicStats)
          this.selectOnePeriod(null);
          this.selectOnePeriodValue(null);
        }
        if (this.resetStatus !== null && !this.resetStatus) {
          this.selectResetStatus(true);
        }

        // if (this.comparingState) {
        //   this.changeTableRowHeader();
        // }
      } else if (route === 'ws') {
        // Загружаем опции для фильтров wordstat
        const fetchOptionsKeywords = this.fetchOptionsKeywords();
        const fetchOptionsGeoLocations = this.fetchOptionsGeoLocations();
        promises.push(fetchOptionsKeywords);
        promises.push(fetchOptionsGeoLocations);
        
        const fetchWordstat = this.fetchWordstat()
        promises.push(fetchWordstat)
      }

      await Promise.all(promises)
    },

    handleChange(evt) {
      this.value = evt.target.value;
      this.open = false;
    },

    setDateRange(v, typeDateRange, typeDate) {
      if (typeof v === "string") {
        const regex = /\d{2}.\d{2}.\d{4}\s*/;
        if (v.match(regex)) {
          const pattern = /(\d{2})\.(\d{2})\.(\d{4})/;
          if (typeDate === "start") {
            let dateRangeElement = v.split("-");
            let startDate = new Date(
              dateRangeElement[0]
                .replaceAll(" ", "")
                .replace(pattern, "$3-$2-$1")
            );
            let endDate = this.dateRange.endDate;
            if (typeDateRange === "dateRangeComparing") {
              endDate = this.dateRangeComparing.endDate;
            }
            if (startDate > this.maxDate) {
              startDate = this.maxDate;
            }
            v = {
              startDate: startDate,
              endDate: endDate,
            };
          } else {
            let dateRangeElement = v;
            let endDate = new Date(
              dateRangeElement.replaceAll(" ", "").replace(pattern, "$3-$2-$1")
            );
            let startDate = this.dateRange.startDate;
            if (typeDateRange === "dateRangeComparing") {
              startDate = this.dateRangeComparing.startDate;
            }
            if (endDate > this.maxDate) {
              endDate = this.maxDate;
            }
            v = {
              startDate: startDate,
              endDate: endDate,
            };
          }
          if (typeDateRange === "dateRange") {
            this.componentDateRange = !this.componentDateRange;
            this.selectDateRange(v);
          } else {
            this.componentDateRangeComparing =
              !this.componentDateRangeComparing;
            this.selectDateRangeComparing(v);
          }
        }
      } else {
        if (typeDateRange === "dateRange") {
          this.selectDateRange(v);
        } else {
          this.selectDateRangeComparing(v);
          const isAfter = moment(v.startDate).isAfter(moment(this.dateRangeModel.endDate))
          this.updateIsCorrectPeriod(!isAfter)
          if (!isAfter) {
            this.filterFormSubmit()
          }
        }
      }
    },
  },
};
</script>
<style></style>
